import React from "react";
import Select from './DisplaySelect';

function DisplayNumeric({index,Numeric,handleChangeSelect,numericList,numericCodeList,vsmMode}) {    

    //Numeric Color Code 정리 - 추후 color Custom으로 변경 시 로직 변경 예정
    const NumericColor = {
        'HR' : '#3DFF3D',
        'PR' : '#3DFF3D',
        'SpO2' : '#09F4F0',
        'RESP' : '#FDDF01',
        'awRR' : '#FFDDBD',
        'NIBP' : '#FF2B5E',
        'IBP1' : '#FF2B5E',
        'IBP2' : '#FDDF01',
        'IBP3' : '#FF8F32',
        'IBP4' : '#34EF8A',
        'EtCO2' : '#FFFFFF',
        'InCO2' : '#FFFFFF',
        'IPI' : '#FFFFFF',
        'Temp1' : '#9B92FF',
        'Temp2' : '#9B92FF',
        'EWS' : '#FFFFFF',
        'GAS' : '#FF8F32',
        'BIS' : '#FFFFFF',
        'Score' : '#FFFFFF',
        'NONE' : ''
    }

    //기존 sample Data이며 내용이 변경될 경우 수정이 필요함.
    const NumericContents = {
        'HR' : { type : 1, content1 : 'bpm', content2 : '120/50', content3 : '60' },
        'PR' : { type : 1, content1 : 'rpm', content2 : '40/8', content3 : '20' },
        'SpO2' : { type : 1, content1 : '%', content2 : '100/90', content3 : '98' },
        'RESP' : { type : 1, content1 : '%', content2 : '100/90', content3 : '98' },
        'awRR' : { type : 1, content1 : 'rpm', content2 : '100/90', content3 : '12' },
        'NIBP' : { type : 2, content1 : 'mmHg', content2 : '---', content3 : '120/80', content4 : '(94)', content5 : '165/85 90/50 110/60' },
        'IBP1' : { type : 2, content1 : 'mmHg', content2 : '---', content3 : '120/80', content4 : '(94)', content5 : '165/85 90/50 110/60' },
        'IBP2' : { type : 2, content1 : 'mmHg', content2 : '---', content3 : '120/80', content4 : '(94)', content5 : '165/85 90/50 110/60' },
        'IBP3' : { type : 2, content1 : 'mmHg', content2 : '---', content3 : '120/80', content4 : '(94)', content5 : '165/85 90/50 110/60' },
        'IBP4' : { type : 2, content1 : 'mmHg', content2 : '---', content3 : '120/80', content4 : '(94)', content5 : '165/85 90/50 110/60' },      
        'EtCO2' : { type : 1, content1 : 'mmHg', content2 : '80/0', content3 : '33' },          
        'InCO2' : { type : 1, content1 : 'mmHg', content2 : '20/0', content3 : '1' },
        'IPI' : { type : 1, content1 : '---', content2 : '8/2', content3 : '---' },
        'Temp1' : { type : 1, content1 : '°C', content2 : '39.0/36.5', content3 : '37.6' },
        'Temp2' : { type : 1, content1 : '°C', content2 : '39.0/36.5', content3 : '37.6' },
        'EWS' : { type : 1, content1 : 'mmHg', content2 : 'LV.2', content3 : '3' },
        'GAS' : { type : 3, content1 : 'O2:---/---', content2 : 'N2O:---/---', content3 : '', content4 : 'CO2:---/---', content5 : 'AA1:---/---', content6 : 'AA2:---/---'},
        'BIS' : { type : 3, content1 : 'SQI:---', content2 : 'N2O:---/---', content3 : '---', content4 : 'SR:---', content5 : 'SEF:---', content6 : 'TP:---'},
        'Score' : { type : 1, content1 : '%', content2 : '70/40', content3 : '22' },
        'NONE' : { type : 1, content1 : '', content2 : '', content3 : '' },
    }
    
    return (
        <>        
            {
                NumericContents[Numeric.measureParameter]?.type == 1 && (
                    <div className="relative flex justify-between w-[100%] h-[60px] bg-[#000] border-[1px] border-[#4E4E4E] px-[2px] pt-[5px] pb-0">            
                        <div className={`flex flex-col flex-wrap items-start justify-end `} style={{color:NumericColor[Numeric.measureParameter], fontFamily: 'Roboto'}}>
                            <span className={`text-[12px] font-extralight`}>{NumericContents[Numeric.measureParameter].content1}</span>
                            <span className={`text-[14px] font-normal`}>{NumericContents[Numeric.measureParameter].content2}</span>
                        </div>
                        <div className={`flex items-center`} style={{color:NumericColor[Numeric.measureParameter], fontFamily: 'Roboto'}}>
                            <span className="text-[${color}] text-[50px]">{NumericContents[Numeric.measureParameter].content3}</span>
                        </div>
                        <div className={`absolute top-[2px] left-[2px]`} style={{color:NumericColor[Numeric.measureParameter]} }>    
                            {
                                vsmMode ? (
                                    <span className="pb-[11px]">{Numeric.measureParameter}</span> 
                                ) : (
                                    <Select options={numericCodeList} value={Numeric.measureParameterId} index={index} selectType={'Numeric'} list={numericList} handleChangeSelect={handleChangeSelect}/>
                                )
                            }
                        </div>
                    </div>
                )
            }

            {
                NumericContents[Numeric.measureParameter]?.type == 2 && (
                    <div className="relative flex justify-between w-[100%] h-[60px] bg-[#000] border-[1px] border-[#4E4E4E] px-[2px] pt-[5px] pb-0">            
                        <div className={`flex flex-col flex-wrap items-start justify-end `} style={{color:NumericColor[Numeric.measureParameter], fontFamily: 'Roboto'}}>
                            <span className={`text-[12px] font-extralight`}>{NumericContents[Numeric.measureParameter].content1}</span>
                            <span className={`text-[12px] font-normal`}>{NumericContents[Numeric.measureParameter].content2}</span>
                        </div>
                        <div className={`flex flex-col items-end justify-end text-[50px]`} style={{color:NumericColor[Numeric.measureParameter], fontFamily: 'Roboto'}}>
                            <div className="flex" style={{color:NumericColor[Numeric.measureParameter]}}>
                                <span className={`text-[26px]`}>{NumericContents[Numeric.measureParameter].content3}</span>
                                <span className={`text-[20px] mt-[3px]`}>{NumericContents[Numeric.measureParameter].content4}</span>
                            </div>                            
                            <span className={`text-[14px] font-normal`}>{NumericContents[Numeric.measureParameter].content5}</span>                            
                        </div>
                        <div className={`absolute top-[2px] left-[2px]`} style={{color:NumericColor[Numeric.measureParameter]}}>
                            {
                                vsmMode ? (
                                    <span>{Numeric.measureParameter}</span> 
                                ) : (
                                    <Select options={numericCodeList} value={Numeric.measureParameterId} index={index} selectType={'Numeric'} list={numericList} handleChangeSelect={handleChangeSelect} />
                                )
                            }
                        </div>
                    </div>
                )
            }

            {
                NumericContents[Numeric.measureParameter]?.type == 3 && (
                    <div className="relative flex justify-around w-[100%] h-[60px] bg-[#000] border-[1px] border-[#4E4E4E] px-[2px] pt-[5px] pb-0">            
                        <div className={`flex flex-col flex-wrap items-start justify-end `} style={{color:NumericColor[Numeric.measureParameter], fontFamily: 'Roboto'}}>                            
                            <span className={`text-[12px] font-medium`}>{NumericContents[Numeric.measureParameter].content1}</span>
                            <span className={`text-[12px] font-medium`}>{NumericContents[Numeric.measureParameter].content2}</span>
                        </div>
                        <div className="flex items-center justify-center" style={{color:NumericColor[Numeric.measureParameter], fontFamily: 'Roboto'}}>
                            <span className={`text-[26px] font-medium`}>{NumericContents[Numeric.measureParameter].content3}</span>
                        </div>
                        <div className={`flex flex-col items-start justify-end text-[50px]`} style={{color:NumericColor[Numeric.measureParameter], fontFamily: 'Roboto'}}>
                            <span className={`text-[12px] font-medium`}>{NumericContents[Numeric.measureParameter].content4}</span>
                            <span className={`text-[12px] font-medium`}>{NumericContents[Numeric.measureParameter].content5}</span>
                            <span className={`text-[12px] font-medium`}>{NumericContents[Numeric.measureParameter].content6}</span>                      
                        </div>
                        <div className={`absolute top-[2px] left-[2px]`} style={{color:NumericColor[Numeric.measureParameter]}}>
                            {
                                vsmMode ? (
                                    <span>{Numeric.measureParameter}</span> 
                                ) : (
                                    <Select options={numericCodeList} value={Numeric.measureParameterId} index={index} selectType={'Numeric'} list={numericList} handleChangeSelect={handleChangeSelect} />
                                )
                            }
                        </div>
                    </div>
                )
            }
        </>
        
    );
}

export default DisplayNumeric;
